import { stats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <strong className="text-3xl md:text-4xl font-heading font-bold text-accent-500">
                {stat.value}
              </strong>
              <div className="mt-2 text-xs md:text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}